import Dropdown from 'components/Dropdown/Dropdown';

const PROPERTY_TYPES = [
	'Single family home',
	'Apartment',
	'Townhouse',
	'Condominium',
	'Mobile home',
	'Multi-family home',
	'Bungalow',
	'Farmhouse'
];

function PropertyTypeDropdown({ selected, onChange }) {
	return (
		<Dropdown
			items={PROPERTY_TYPES}
			selected={selected}
			onChange={onChange}
			variant="outlined"
			label="Property type *"
		/>
	);
}

export default PropertyTypeDropdown;
